import { render, staticRenderFns } from "./PurchaseOrderFilterDialog.vue?vue&type=template&id=2512e6d2&"
import script from "./PurchaseOrderFilterDialog.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderFilterDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports